(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-collection-drawer]').forEach(function (root) {
      var dialog = root.querySelector('dialog');
      if (!dialog) return;
      var handle = root.getAttribute('data-cd-handle');
      var body = root.querySelector('[data-cd-body]');
      var loaded = false, loadingMore = false, nextPage = null, grid = null;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var baseUrl = base + 'collections/' + encodeURIComponent(handle) + '?section_id=collection-drawer-content';

      function normalise(word) {
        return word.toLowerCase().replace(/[^a-z0-9.]/g, '');
      }

      // Card titles read "<family> <style> - <colour>", e.g.
      // "(Nano) Najwa Sport Niya 3.0 - Squash". The family words repeat on every
      // card in the drawer, so intersecting all of them isolates the style name
      // ("(Nano) Niya") no matter which product page the drawer was opened from.
      function relabel() {
        var entries = [];
        dialog.querySelectorAll('.product-card__title a, .product-card__title [data-product-link]').forEach(function (link) {
          var full = link.getAttribute('data-cd-full');
          if (full === null) {
            full = link.textContent.trim();
            link.setAttribute('data-cd-full', full);
          }
          var match = full.match(/ - | in /i);
          if (!match) return;
          entries.push({
            link: link,
            words: full.slice(0, match.index).trim().split(/\s+/).filter(Boolean),
            colour: full.slice(match.index + match[0].length).trim()
          });
        });
        if (!entries.length) return;

        var shared = null;
        entries.forEach(function (entry) {
          var keys = {};
          entry.words.forEach(function (word) { keys[normalise(word)] = true; });
          if (shared === null) {
            shared = keys;
            return;
          }
          Object.keys(shared).forEach(function (key) {
            if (!keys[key]) delete shared[key];
          });
        });

        entries.forEach(function (entry) {
          var style = entry.words.filter(function (word) {
            var key = normalise(word);
            return key && !shared[key];
          }).join(' ');
          entry.link.textContent = '';
          if (style) {
            var styleEl = document.createElement('span');
            styleEl.className = 'collection-drawer__style';
            styleEl.textContent = style;
            entry.link.appendChild(styleEl);
          }
          var colourEl = document.createElement('span');
          colourEl.className = 'collection-drawer__colour';
          colourEl.textContent = entry.colour;
          entry.link.appendChild(colourEl);
        });
      }

      function fillIfNeeded() {
        if (nextPage && !loadingMore && body.scrollHeight <= body.clientHeight + 10) loadMore();
      }

      function loadMore() {
        if (loadingMore || !nextPage) return;
        loadingMore = true;
        fetch(baseUrl + '&page=' + nextPage)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var newGrid = tmp.querySelector('[data-cd-grid]');
            nextPage = newGrid ? (newGrid.getAttribute('data-cd-next') || null) : null;
            if (newGrid && grid) {
              var frag = document.createDocumentFragment();
              while (newGrid.firstElementChild) frag.appendChild(newGrid.firstElementChild);
              grid.appendChild(frag);
              relabel();
            }
            loadingMore = false;
            fillIfNeeded();
          })
          .catch(function () { loadingMore = false; });
      }

      function onScroll() {
        if (!nextPage || loadingMore) return;
        if (body.scrollTop + body.clientHeight >= body.scrollHeight - 320) loadMore();
      }

      function loadContent() {
        if (loaded || !handle || !body) return;
        loaded = true;
        fetch(baseUrl)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            body.innerHTML = html;
            grid = body.querySelector('[data-cd-grid]');
            nextPage = grid ? (grid.getAttribute('data-cd-next') || null) : null;
            relabel();
            body.addEventListener('scroll', onScroll, { passive: true });
            fillIfNeeded();
          })
          .catch(function () {
            loaded = false;
            body.innerHTML = '<div class="collection-drawer__loading"><a class="collection-drawer__viewall" href="' + base + 'collections/' + encodeURIComponent(handle) + '">View collection</a></div>';
          });
      }

      function openDrawer() {
        loadContent();
        document.documentElement.classList.add('cd-scroll-lock');
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }

      var opener = root.querySelector('[data-cd-open]');
      if (opener) opener.addEventListener('click', openDrawer);
      dialog.querySelectorAll('[data-cd-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('cd-scroll-lock');
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-colour-swatches"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-colour-swatches]').forEach(function (root) {
    var row = root.querySelector('.colour-swatches__row');
    if (!row) return;
    var prev = root.querySelector('[data-cs-prev]');
    var next = root.querySelector('[data-cs-next]');
    var handle = root.getAttribute('data-cs-handle');
    var current = root.getAttribute('data-cs-current');
    var nextPage = row.getAttribute('data-sw-next') || null;
    var loadingMore = false;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Mobile renders a static grid (see stylesheet), so none of the carousel
    // behaviour below applies — but the grid does collapse to one row, and the
    // toggle opens the rest. Function declarations hoist, so loadMore is
    // callable from here even though it is defined further down.
    if (window.matchMedia('(max-width: 749px)').matches) {
      markActive(row);

      var toggle = root.querySelector('[data-cs-toggle]');
      if (toggle) {
        toggle.hidden = false;
        toggle.addEventListener('click', function () {
          var collapsed = root.classList.toggle('is-collapsed');
          toggle.setAttribute('aria-expanded', String(!collapsed));
          toggle.textContent = collapsed ? toggle.dataset.labelMore : toggle.dataset.labelLess;

          // Either direction resizes the grid under the customer's finger, so
          // put them back on the first row rather than wherever the reflow left
          // them: collapsing 135 colours drops them into whatever now occupies
          // that scroll position, and expanding pushes the row they were
          // reading off the top. scroll-margin-top clears the sticky header.
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });

          // Expanding means every colour, not just the first page Liquid
          // rendered. loadMore chains through the remaining pages on its own.
          if (!collapsed) loadMore();
        });
      }

      return;
    }

    function markActive(scope) {
      if (!current) return;
      (scope || row).querySelectorAll('[data-sw-handle="' + current + '"]').forEach(function (a) {
        a.classList.add('is-active');
        a.setAttribute('aria-current', 'true');
      });
    }

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var overflow = max > 2;
      row.classList.toggle('is-scrollable', overflow);
      if (prev) prev.hidden = !overflow || row.scrollLeft <= 0;
      if (next) next.hidden = (!overflow && !nextPage) || (row.scrollLeft >= max - 1 && !nextPage);
    }

    function loadMore() {
      if (loadingMore || !nextPage || !handle) return;
      loadingMore = true;
      fetch(base + 'collections/' + encodeURIComponent(handle) + '?section_id=product-swatch-content&page=' + nextPage)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var chunk = tmp.querySelector('.colour-swatches__chunk');
          nextPage = chunk ? (chunk.getAttribute('data-sw-next') || null) : null;
          if (chunk) {
            var frag = document.createDocumentFragment();
            while (chunk.firstElementChild) frag.appendChild(chunk.firstElementChild);
            row.appendChild(frag);
            markActive(row);
          }
          loadingMore = false;
          update();
          fillIfNeeded();
        })
        .catch(function () { loadingMore = false; });
    }

    function fillIfNeeded() {
      if (nextPage && !loadingMore && row.scrollWidth <= row.clientWidth + 10) loadMore();
    }

    var dragActive = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragActive = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartScroll = row.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragActive) return;
      var dx = e.clientX - dragStartX;
      if (!dragMoved && Math.abs(dx) > 4) {
        dragMoved = true;
        row.classList.add('is-grabbing');
      }
      if (dragMoved) row.scrollLeft = dragStartScroll - dx;
    });
    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      row.classList.remove('is-grabbing');
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    row.addEventListener('click', function (e) {
      if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function step(dir) {
      row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { loadMore(); step(1); });
    row.addEventListener('scroll', function () {
      update();
      if (nextPage && !loadingMore && row.scrollLeft + row.clientWidth >= row.scrollWidth - 400) loadMore();
    }, { passive: true });
    window.addEventListener('resize', update);

    markActive(row);
    var activeItem = row.querySelector('.colour-swatches__item.is-active');
    if (activeItem) {
      activeItem.scrollIntoView({ inline: 'center', block: 'nearest' });
    }
    update();
    fillIfNeeded();
  });

  /* Colour quick view -------------------------------------------------------
     On a Main Product the swatch is the only way forward, and following it
     costs a full page load. Open the theme's existing product quickview modal
     instead — same markup product-card.js builds, so title, gallery, price,
     size picker and Add to cart all come along.

     Every failure path falls through to the plain <a href>, so the colour page
     stays reachable for crawlers, no-JS, and anything unexpected.

     ANALYTICS: the Meta/GA web pixels live in Shopify's sandbox and only hear
     standard events, so a drawer open fires no ViewContent on its own. We
     publish `colour_quickview_viewed` with the same fields the real pixel
     sends; a custom pixel in Admin > Customer events must relay it. Until that
     pixel exists, colour-level retargeting signal is NOT being replaced. */
  (function () {
    var template = document.querySelector('#product-quickview');
    if (!template) return;

    // The drawer is a page as far as the customer is concerned, so Back should
    // close it rather than leave the product entirely — which is what happened
    // before, since opening it changed nothing about the history stack. Opening
    // pushes the colour's own URL, so the address bar matches what is on screen
    // and a reload lands on the real product page.
    var HISTORY_KEY = 'tpColourQuickview';

    // Where the page was before the first drawer opened, so closing can put it
    // back. Recorded only on a fresh open: stepping between colours happens
    // while the scroll lock holds the body, and on iOS that means reading
    // window.scrollY would give 0 and lose the real position.
    var pageScroll = 0;

    // Closing the drawer runs history.back(), and the browser restores that
    // entry's own scroll position when the navigation lands — after any frame
    // we could restore in, so it wins and the customer ends up somewhere else.
    // The entry was recorded while the drawer held the page, which on iOS means
    // it was recorded against a body pinned at `position: fixed`, so the value
    // it restores is not where the customer was.
    //
    // Take the decision away from the browser for the length of the drawer and
    // hand it back on close.
    function holdPageScroll() {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    }

    // Leaving with the drawer open — "View product", or a tap on a link inside
    // it — would carry the manual setting into the next page and cost the
    // customer their position when they come back.
    window.addEventListener('pagehide', function () {
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    });

    function restorePageScroll() {
      // Two frames: the first lets ModalDialog.hide() release the scroll lock,
      // the second lets the back navigation land. Restoring before either would
      // be overwritten by it.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, pageScroll);
          if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
        });
      });
    }

    window.addEventListener('popstate', function () {
      var open = document.querySelector('.product-quickview');
      if (!open) return;
      var closer = open.querySelector('[data-modal-close]');
      if (closer) closer.click();
    });

    // Fetch the colour product's own page, not ?section_id=main-product: the
    // size picker is a JSON-template block, and a bare section render drops it
    // (verified — 0 size inputs vs S/M/L/XL on the full page). Adding to cart
    // without a size choice is worse than the extra weight. Responses are
    // cached and prefetched on intent so the cost lands before the tap.
    var cache = new Map();

    function load(href) {
      if (!cache.has(href)) {
        cache.set(href, fetch(href).then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        }).catch(function (error) {
          cache.delete(href);
          throw error;
        }));
      }
      return cache.get(href);
    }

    ['pointerenter', 'touchstart'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var link = event.target.closest && event.target.closest('.colour-swatches__item[data-sw-handle]');
        if (link && link.closest('[data-cs-quickview]')) load(link.href).catch(function () {});
      }, { capture: true, passive: true });
    });

    function publishView(link, modal) {
      var selected = modal && modal.querySelector('input[name="id"]');
      var view = {
        productId: link.dataset.swId,
        variantId: selected ? selected.value : '',
        handle: link.dataset.swHandle,
        title: link.dataset.swTitle,
        category: link.dataset.swType,
        price: Number(link.dataset.swPrice),
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MYR',
        url: link.href
      };

      // Two audiences for the same view. The Shopify channel reaches the custom
      // pixel, which is the only way to raise Meta's ViewContent from a sandbox.
      // The DOM event stays on this page, where analytics-colour-quickview can
      // read the first-party cookies Google needs.
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') {
        analytics.publish('colour_quickview_viewed', view);
      }

      document.dispatchEvent(new CustomEvent('tp:colour-quickview-viewed', { detail: view }));
    }

    // The drawer opens on the first available variant, the same as the product
    // page. It used to open with nothing selected so nobody could buy a size
    // they had not asked for, but clearing the pre-selection after the markup
    // arrived made the Add to cart button visibly drop to its disabled state a
    // beat after the panel appeared, which read as a flicker. Matching the
    // product page is both steadier and what customers already know.

    // The gallery markup arrives as a string and goes in while the drawer is
    // still hidden. A `<video autoplay>` that is inserted into a subtree nobody
    // is rendering never starts, and the browser does not come back to it when
    // the drawer is shown — so the shot sits on its poster frame. Ask once, on
    // the way in. Muted playback needs no user gesture; the catch is for the
    // browsers that disagree, where the customer still has the controls.
    function playGalleryVideos(modal) {
      modal.querySelectorAll('video[autoplay]').forEach(function (video) {
        video.muted = true;
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });
    }

    function build(html, link) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var details = doc.querySelector('[data-product-details]');
      if (!details) return null;

      // product-card.js also drops deferred-media, which is how the theme
      // renders video — its quick view has no gallery to put one in. Ours does,
      // so keep them and match the product page's own media order. Only
      // modal-opener is skipped; that is the lightbox shell, not a shot.
      var media = Array.from(doc.querySelectorAll('[data-product-media]')).filter(function (node) {
        var tag = node.children[0] && node.children[0].tagName.toLowerCase();
        return tag !== 'modal-opener';
      });

      var modal = template.content.cloneNode(true).querySelector('.product-quickview');
      var suffix = link.dataset.swHandle;
      modal.id = modal.id + suffix;
      modal.querySelectorAll('[data-modal-close]').forEach(function (el) { el.id = el.id + suffix; });

      // Keep every shot, not just the first. Touch swipes the strip sideways;
      // desktop scrolls it down and gets arrows, since a mouse has no swipe and
      // nothing on screen says the column moves.
      var mediaEl = modal.querySelector('[data-media-wrapper]');

      // Both rewrites happen on the HTML string, not on the elements after
      // injection. srcset is resolved while the markup is parsed, so a sizes
      // attribute set afterwards is simply ignored — the browser has already
      // chosen, and it chose for the product page.
      //
      // sizes: the markup is built for the product page's gallery and ends at
      // 1000px. This column is 368px on desktop, so the full master was being
      // fetched for a third of the width.
      //
      // loading: lazy is right on a long page and wrong in a strip of 3 to 9
      // shots, where the peek at the next panel showed empty background until
      // that image decided to load. Correct sizes makes loading them all cheap
      // enough to just do it.
      mediaEl.innerHTML = media
        .map(function (n) { return n.innerHTML; })
        .join('')
        .replace(/sizes="[^"]*"/g, 'sizes="(min-width: 990px) 400px, 92vw"')
        .replace(/loading="lazy"/g, 'loading="eager"');

      // [data-media-wrapper] IS the scroll box, so an arrow placed inside it
      // scrolls away with the photos. Wrap it in a frame that stays put.
      var mediaFrame = document.createElement('div');
      mediaFrame.className = 'product-quickview__media-frame';
      mediaEl.parentElement.insertBefore(mediaFrame, mediaEl);
      mediaFrame.appendChild(mediaEl);

      if (media.length > 1) {
        // Position counter. Lives on the frame so it holds still while the
        // photos slide under it, same as the badge.
        var counter = document.createElement('span');
        counter.className = 'product-quickview__counter';
        counter.setAttribute('aria-live', 'polite');
        mediaFrame.appendChild(counter);

        var syncCounter = function () {
          // Panels snap on their centres, not on multiples of their width, so
          // measure which centre is nearest the middle of the frame.
          var middle = mediaEl.getBoundingClientRect().left + mediaEl.clientWidth / 2;
          var nearest = 0;
          var shortest = Infinity;
          Array.prototype.forEach.call(mediaEl.children, function (panel, index) {
            var box = panel.getBoundingClientRect();
            var distance = Math.abs(box.left + box.width / 2 - middle);
            if (distance < shortest) { shortest = distance; nearest = index; }
          });
          counter.textContent = (nearest + 1) + '/' + mediaEl.children.length;
        };
        syncCounter();
        mediaEl.addEventListener('scroll', syncCounter, { passive: true });

        // A mouse cannot swipe, and the arrows are gone. Drag it instead —
        // the same pattern the swatch row already uses. Touch is left alone so
        // native scrolling keeps its momentum.
        var dragging = false, startX = 0, startScroll = 0, moved = false;

        mediaEl.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse') return;
          dragging = true;
          moved = false;
          startX = event.clientX;
          startScroll = mediaEl.scrollLeft;
        });

        window.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          var dx = event.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            moved = true;
            mediaEl.classList.add('is-grabbing');
          }
          if (moved) mediaEl.scrollLeft = startScroll - dx;
        });

        ['pointerup', 'pointercancel'].forEach(function (type) {
          window.addEventListener(type, function () {
            if (!dragging) return;
            dragging = false;
            // Dropping is-grabbing restores scroll-snap-type, and the browser
            // settles on the nearest shot itself. Doing it by hand as well
            // produced a visible double-move, since CSS snaps on centres and
            // the manual maths snapped on widths.
            mediaEl.classList.remove('is-grabbing');
          });
        });

        mediaEl.addEventListener('dragstart', function (event) { event.preventDefault(); });
      }

      // Picking a size should bring up the shot assigned to it. The theme's own
      // updateMedia() looks for [data-product-quickview-media], which this
      // drawer does not use, and falls through to document.querySelector(
      // 'product-media') — the gallery on the page behind, which the customer
      // cannot even see. Scroll our own strip instead.
      //
      // Listens for the hidden id input, not the size radio: the theme answers
      // the radio by writing the new variant id into that input, so by the time
      // this fires the choice is settled. Reading selector.currentVariant off
      // the radio event gave the previous variant and the gallery moved one
      // pick behind.
      modal.addEventListener('change', function (event) {
        var target = event.target;
        if (!target.matches || !target.matches('input[name="id"]')) return;

        var variantId = Number(target.value);
        var selector = modal.querySelector('product-selector');
        if (!selector || typeof selector.getVariantData !== 'function') return;

        var variant = selector.getVariantData().find(function (candidate) {
          return candidate.id === variantId;
        });
        var mediaId = variant && variant.featured_media && variant.featured_media.id;
        if (!mediaId) return;

        var panel = mediaEl.querySelector('[data-media-id="' + mediaId + '"]');
        if (!panel) return;

        // scrollTo on the strip, not scrollIntoView: the strip scrolls sideways
        // on touch and down on desktop, and scrollIntoView would drag the page
        // behind the drawer along with it.
        mediaEl.scrollTo({ top: panel.offsetTop, left: panel.offsetLeft, behavior: 'smooth' });
      });

      var wrapper = modal.querySelector('[data-details-wrapper]');
      wrapper.innerHTML = details.innerHTML;

      // The clone carries the product page's own section id, and the theme's
      // scripts look their targets up across the whole document: the selector
      // writes the chosen variant into '#product-form-<section>' and the price
      // into '#price-<section>'. With both copies answering to the same id, the
      // drawer was driving the page behind it — picking a size rewrote the
      // address bar back to the page's product with the drawer's variant, and
      // the page's price changed underneath. Give the clone its own section id
      // so those lookups can only find one of them.
      //
      // Done here, before the modal enters the document, so the custom elements
      // upgrade already holding the new ids.
      var cloneSelector = wrapper.querySelector('[data-section]');
      if (cloneSelector) {
        var oldSection = cloneSelector.dataset.section;
        var newSection = oldSection + '-qv-' + link.dataset.swHandle;
        var swap = function (value) { return value.split(oldSection).join(newSection); };

        // Keep the original alongside the new one: only the original names a
        // section Shopify can render, so product-selector.js still has to ask
        // for it when it re-fetches the variant's price and stock notice.
        modal.querySelectorAll('[data-section]').forEach(function (el) {
          el.dataset.sectionSource = oldSection;
          el.dataset.section = newSection;
        });
        ['id', 'form', 'for', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(function (attr) {
          modal.querySelectorAll('[' + attr + '*="' + oldSection + '"]').forEach(function (el) {
            el.setAttribute(attr, swap(el.getAttribute(attr)));
          });
        });
      }

      window.tpRequireExplicitChoice(wrapper);

      // The drawer strips the product page down, and the badge went with it —
      // "New", "Sale", "In store only" are exactly the things worth knowing
      // before buying. Rather than re-derive the rules, lift the badge the
      // swatch already carries: same Liquid decided it, so the two can never
      // disagree.
      var swatchBadge = link.querySelector('.badge');
      if (swatchBadge) {
        var badge = swatchBadge.cloneNode(true);
        badge.classList.remove('product-card__badge');
        badge.classList.add('product-quickview__badge');
        // Onto the frame, not the scroll box: the frame holds still while the
        // photos slide under it, so the badge stays on screen throughout.
        mediaFrame.appendChild(badge);
      }

      // The Details copy, handed over on the swatch (see product-swatch-item).
      if (link.dataset.swDetails) {
        var extra = document.createElement('div');
        extra.className = 'product-quickview__extra rte';
        extra.innerHTML = link.dataset.swDetails;
        wrapper.appendChild(extra);
      }

      // The drawer is deliberately thin (see product-quickview.css): gallery,
      // title, price, variant, Add to cart. Everything else lives one tap away.
      var viewProduct = document.createElement('a');
      viewProduct.className = 'product-quickview__view-product';
      viewProduct.href = link.href;
      viewProduct.textContent = 'View product';
      wrapper.appendChild(viewProduct);

      return modal;
    }

    // Colours in the order the row shows them, hidden ones included: the
    // mobile grid only reveals eight until "show all", but stepping through
    // the family should not stop at whatever happens to be on screen.
    function siblings(link) {
      var root = link.closest('[data-colour-swatches]');
      if (!root) return [];
      return Array.prototype.slice.call(root.querySelectorAll('.colour-swatches__item[data-sw-handle]'));
    }

    // Stepping to the neighbouring colour without closing the drawer, so the
    // two can be compared. Replaces the history entry rather than pushing:
    // Back stays "close the drawer", not "walk back through every colour
    // looked at", while the URL still matches what is on screen.
    //
    // The three end up on one line — previous, view product, next — so the
    // column ends in a single quiet band instead of two stacked blocks with
    // dead space between them. Ends of the family keep their button in place,
    // dimmed, so the row never reflows as you step through.
    function buildFooter(modal, link) {
      var wrapper = modal.querySelector('[data-details-wrapper]');
      var viewProduct = wrapper.querySelector('.product-quickview__view-product');
      var list = siblings(link);
      var index = list.indexOf(link);
      if (index === -1 || list.length < 2) return;

      var footer = document.createElement('div');
      footer.className = 'product-quickview__footer';

      function stepButton(side, target, label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-quickview__step product-quickview__step--' + side;
        button.textContent = label;
        if (!target) {
          button.disabled = true;
        } else {
          // The neighbour is the likeliest next tap, so pay for it now.
          load(target.href).catch(function () {});
          button.addEventListener('click', function () {
            // Hand the outgoing drawer over rather than closing it here: shut
            // first and there is a frame with nothing on screen, which is the
            // flicker. openFor closes it once the replacement is up.
            openFor(target, true, modal);
          });
        }
        return button;
      }

      footer.appendChild(stepButton('prev', list[index - 1], '\u2039 Previous'));
      if (viewProduct) footer.appendChild(viewProduct);
      footer.appendChild(stepButton('next', list[index + 1], 'Next \u203a'));

      wrapper.appendChild(footer);
    }

    function openFor(link, replaceHistory, outgoing) {
      if (!outgoing) {
        pageScroll = window.scrollY;
        holdPageScroll();
      }

      return load(link.href)
        .then(function (html) {
          var modal = build(html, link);
          if (!modal) throw new Error('no product details in section');

          // Stepping through colours reuses the open/close machinery, so
          // without this the customer watches the drawer play its entry
          // animation on every tap — it reads as the panel opening again
          // rather than its contents changing. Skip the transition and the
          // swap looks like one panel updating in place.
          if (outgoing) modal.classList.add('product-quickview--instant');

          document.body.append(modal);
          // After the modal is in the document: the variant the drawer opened on
          // is whatever the hidden input holds, and the analytics ids need it.
          publishView(link, modal);

          var state = {};
          state[HISTORY_KEY] = link.dataset.swHandle;
          if (replaceHistory) {
            history.replaceState(state, '', link.href);
          } else {
            history.pushState(state, '', link.href);
          }

          // Closing by the X or the overlay has to pop that entry too, or the
          // stack fills with drawers the customer has already dismissed.
          //
          // The page's position is put back by hand as well. On iOS the scroll
          // lock works by pinning the body with `position: fixed; top: -scrollY`
          // and scrolling back to that offset on release — and it re-measures
          // that offset 300ms in to allow for Safari's address bar changing
          // height, which is enough to land the customer somewhere they never
          // were. Restoring the position we recorded before opening makes the
          // close land in the same place on every browser. It is a no-op
          // wherever the lock already did the right thing, since the page
          // cannot scroll while the drawer is open.
          modal.addEventListener('click', function (event) {
            if (!event.target.closest('[data-modal-close]')) return;
            if (history.state && history.state[HISTORY_KEY]) history.back();
            restorePageScroll();
          });

          buildFooter(modal, link);

          setTimeout(function () {
            modal.show(link);
            // Now that the replacement is on screen, retire the old one. Doing
            // it in this order means the two overlap for a frame instead of
            // leaving a gap.
            if (outgoing) outgoing.hide();
            playGalleryVideos(modal);
          }, 1);
        })
        .catch(function () {
          window.location.href = link.href;
        });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.colour-swatches__item[data-sw-handle]');
      if (!link) return;
      if (!link.closest('[data-cs-quickview]')) return;
      // Let the browser handle new-tab, download and non-primary clicks.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      openFor(link, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
